"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRootNode = void 0;
const translation_1 = require("./translation");
const ROOT_NODE_NAME = 'Root';
const resolveRootNode = (input) => {
    const assumedRootNode = Array.isArray(input) ? input[0] : input;
    if (assumedRootNode.type === 'FOLDER' &&
        (assumedRootNode.name === ROOT_NODE_NAME || assumedRootNode.name === '')) {
        return Object.assign(Object.assign({}, assumedRootNode), { name: (0, translation_1.getLocalization)('components/folderTreeNew/rootFolder') });
    }
    return assumedRootNode;
};
exports.resolveRootNode = resolveRootNode;
//# sourceMappingURL=nodes.js.map